module.exports = __webpack_public_path__ + "static/img/gomfirst.276a375.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/gomfirst.jpg
 ** module id = 274
 ** module chunks = 2
 **/